import { useEffect, useRef, useState } from "react";
import QuestionIcon from "@/assets/aiqa/ic_question.svg";
import EnterIcon from "@/assets/aiqa/ic_enter.svg";
import ColorFulEnterIcon from "@/assets/aiqa/ic_enter_colorful.svg";
import "./index.less";
import Popover from "@/component/PopoverRc";
import GuessModel from "../GuessModel";
import ChatStore from "@/store/chat.store";
import { MessageSource } from "@/services/api_question";
import { RuningInLink } from "@/constants";

interface AIInputProps {
  value: string;
  onChange: (v: string) => void;
  onConfirm: (v: string, source: MessageSource) => void;
}

const AIInput = (props: AIInputProps) => {
  const { value, onChange, onConfirm } = props;

  const [isFocus, setIsFocus] = useState(false);
  const [isComposition, setIsComposition] = useState(false);
  const [disableFocus, setDisableFocus] = useState(false);

  const [questionPopoverVisible, setQuestionPopoverVisible] = useState(false);
  const initialHeightRef = useRef(0);

  const aiInputRef = useRef<HTMLDivElement>(null);
  const textAreaContainer = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [inputHeight, setInputHeight] = useState(20);

  const geussQuestions = ChatStore((state) => state.geussQuestions);

  useEffect(() => {
    if (value.trim() === "") {
      setDisableFocus(true);
    } else {
      setDisableFocus(false);
    }
  }, [value]);

  useEffect(() => {
    initialHeightRef.current = inputRef.current?.style.height ? +inputRef.current?.style.height : 0;
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (aiInputRef.current && !aiInputRef.current.contains(event.target as Node)) {
      setIsFocus(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleInput = (e: any) => {
    if (!inputRef.current) return;
    inputRef.current.style.height = "auto";
    const newHeight = Math.min(inputRef.current.scrollHeight, 130);
    inputRef.current.style.height = newHeight + "px";
    textAreaContainer.current!.style.height = newHeight + "px";
    setInputHeight(newHeight);
    onChange(e.target.value);
  };

  const handleChoose = (question: string) => {
    if (inputRef.current) {
      inputRef.current.value = question;
      onChange(question);
      onConfirm(question, MessageSource.QUESTION_LIB);
      setQuestionPopoverVisible(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !isComposition) {
      event.preventDefault();
      onConfirm?.(value, MessageSource.MANUAL);
    }
  };

  return (
    <>
      <div
        className={`ai-input-wrap ${isFocus ? "focus" : ""}`}
        ref={aiInputRef}
        onClick={() => {
          setIsFocus(true);
          inputRef.current?.focus();
        }}
        onMouseDown={() => {
          setIsFocus(true);
        }}
      >
        <div className="wrap">
          <div ref={textAreaContainer} className="textAreaContainer">
            <textarea
              value={value}
              onInput={handleInput}
              onCompositionStart={() => {
                setIsComposition(true);
              }}
              onCompositionEnd={() => {
                setIsComposition(false);
              }}
              onKeyDown={handleKeyDown}
              ref={inputRef}
              className="ai-input"
              placeholder="询问关于这场会议的任何问题"
            />
          </div>
          <div className="ai-input-tool">
            <Popover
              destroyTooltipOnHide
              hover={false}
              placement="topLeft"
              onVisibleChange={setQuestionPopoverVisible}
              visible={questionPopoverVisible}
              content={<GuessModel questionList={geussQuestions} onChooseQuestion={handleChoose} className="popover-guess" />}
              align={{
                offset: [RuningInLink ? -18 : -50, -5],
              }}
            >
              <img src={QuestionIcon} />
            </Popover>
            <div className="split"></div>
            {isFocus && !disableFocus ? (
              <img
                src={ColorFulEnterIcon}
                onClick={() => {
                  onConfirm?.(value, MessageSource.MANUAL);
                }}
              />
            ) : (
              <img src={EnterIcon} />
            )}
          </div>
        </div>
      </div>
      <div className={`ai-input-placeholder`}>
        <div
          className="min-h-5"
          style={
            inputHeight
              ? {
                  height: inputHeight,
                }
              : {}
          }
        ></div>
      </div>
    </>
  );
};

export default AIInput;
